/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { Box, xcss } from '@atlaskit/primitives';
import { Card, ElementName, SmartLinkPosition, SmartLinkSize, SmartLinkTheme, TitleBlock } from '../../../../index';
var hoverStyles = xcss({
  ':hover': {
    backgroundColor: 'color.background.input.hovered',
    borderRadius: 'border.radius.100',
    marginInline: 'space.negative.100',
    paddingInline: 'space.100'
  }
});
var relatedLinkItemStyles = css({
  paddingTop: "var(--ds-space-100, 8px)",
  paddingBottom: "var(--ds-space-100, 8px)",
  gap: "var(--ds-space-150, 12px)",
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
var RelatedLinkItem = function RelatedLinkItem(_ref) {
  var url = _ref.url,
    testId = _ref.testId;
  var subtitle = [{
    name: ElementName.Provider,
    hideIcon: true
  }];
  var ui = {
    hideElevation: true,
    hidePadding: true,
    hideBackground: true,
    theme: SmartLinkTheme.Black,
    clickableContainer: true,
    size: SmartLinkSize.Large
  };
  return jsx(Box, {
    testId: testId,
    xcss: hoverStyles
  }, jsx(Card, {
    appearance: "block",
    ui: ui,
    url: url
  }, jsx(TitleBlock, {
    maxLines: 1,
    hideTitleTooltip: true,
    position: SmartLinkPosition.Center,
    subtitle: subtitle,
    overrideCss: relatedLinkItemStyles,
    anchorTarget: "_blank"
  })));
};
export default RelatedLinkItem;